import Footer from "../components/Footer.jsx";
import { useLocalStorage } from "../hooks/useLocalStorage.jsx";
import { useState } from "react";
import Input from "../components/FormElements/Input"; 
import { callAPI } from "../hooks/CallAPI.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navigate, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";
import LoadingWrapper from '../components/LoadingWrapper'; 
import { CircleCheckBig } from 'lucide-react';



const FirstLogin = () => {
    const [user, setUser] = useLocalStorage("user", null);
    const [user_login, setUserLogin] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token_first_connexion = searchParams.get("token");

    if (user) {
        return <Navigate to="/dashboard" />;
    }

    // Fonction de validation du mot de passe
    const validatePassword = (password) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;
        return regex.test(password);
    };

    // Fonction pour gérer la soumission du formulaire
    const handleFirstLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Vérification des mots de passe
        if (password !== confirmPassword) {
            toast.error("Les mots de passe ne correspondent pas.");
            setIsLoading(false);
            return;
        }

        if (!validatePassword(password)) {
            toast.error("Le mot de passe ne respecte pas les critères de sécurité.");
            setIsLoading(false);
            return;
        }

        try {
            if (!user_login || !password || !token_first_connexion) {
                toast.error("Veuillez remplir tous les champs.");
                return;
            }
        
            console.log("Envoi du mot de passe en cours");
            const response = await callAPI('/set-password', {
                user_login: user_login, password: password, token_first_connexion: token_first_connexion
            });
        
                console.log(response);

            if (response.success) {
                toast.success("Mot de passe créé avec succès !");
                localStorage.removeItem('firstLogin');
                navigate('/');
            } 
            
        } catch (error) {
            toast.error("Erreur lors de la création du mot de passe.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col justify-between h-screen">
            <div className="header bg-mgray text-mdark py-8 px-10 text-center">
                <h1 className="text-xl sm:text-4xl font-extrabold text-mlime mb-4 uppercase">Première connexion</h1>
                <p className="text-lg font-bold text-custom-color">Bienvenue dans votre espace client</p>
            </div>

            <div className="container pt-10 flex flex-col items-center  p-4">
                <p className="">Pour accéder à votre espace client sécurisé, vous devez définir un mot de passe conforme aux recommandations suivantes :</p>
                <ul className="mt-4 ml-8">
                    <li><CircleCheckBig className="inline pr-1 w-5 text-mlime"/> Au moins 8 caractères</li>
                    <li><CircleCheckBig className="inline pr-1 w-5 text-mlime"/> Inclure une majuscule et une minuscule</li>
                    <li><CircleCheckBig className="inline pr-1 w-5 text-mlime"/> Contenir au moins un chiffre</li>
                    <li><CircleCheckBig className="inline pr-1 w-5 text-mlime"/> Inclure au moins un caractère spécial (*@$!%*?&*)</li>
                </ul>
            </div>

            <div className="container mx-auto px-10 py-10">
                <form id="firstLoginForm" className="m-10 w-full max-w-md mx-auto" onSubmit={handleFirstLogin}>
                    
                    <Input
                        name="user_login"
                        label="Confirmer votre identifiant de connexion"
                        value={user_login}
                        onChange={(e) => setUserLogin(e.target.value)}
                    />

                    <div className="relative mt-4">
                        <Input
                            name="password"
                            label="Définir un mot de passe"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type={showPassword ? "text" : "password"} 
                        />
                     
                    </div>

                    <div className="relative mt-4">
                        <Input
                            name="confirmPassword"
                            label="Confirmer le mot de passe"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            type={showPassword ? "text" : "password"} 
                        />
                     
                    </div>

                    <div className="mt-4 flex items-center">
                        <input
                            type="checkbox"
                            id="showPasswordCheckbox"
                            checked={showPassword}
                            onChange={() => setShowPassword(!showPassword)}
                            className="mr-2"
                        />
                        <label htmlFor="showPasswordCheckbox" className="text-sm">Afficher les mots de passe</label>
                    </div>

                    <div className="relative mt-6">
                        <button type="submit" className="bg-mlime px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold text-center m-auto  duration-500 hover:bg-colorbutton">
                            <LoadingWrapper isLoading={isLoading}>
                            Créer votre mot de passe <FontAwesomeIcon className="ml-3" icon="fa-regular fa-paper-plane" />
                            </LoadingWrapper>
                        </button>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default FirstLogin;
